import React from 'react';
import PropTypes from 'prop-types';
import Select from 'material-ui/Select';
import withStyles from 'material-ui/styles/withStyles';
import {MenuItem} from 'material-ui/Menu';
import styles from './styles';

const LanguageSelect = ({
	value, handleChange, languages, classes
}) => (
	<div className={classes.container}>
		<p className={classes.label}>Choose your language</p>
		<Select
			value={value}
			onChange={handleChange}
			className={classes.select}
		>
			{languages.map(lang => (
				<MenuItem
					key={lang.key}
					value={lang.key}
				>
					{lang.value}
				</MenuItem>
			))}
		</Select>
	</div>
);

LanguageSelect.propTypes = {
	value: PropTypes.string,
	classes: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired,
	languages: PropTypes.array.isRequired
};

export default withStyles(styles)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/client/components/main/collections/language-select/select.jsx